import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

function StartTest() {
  const [writingErrorMsg, setWritingErrorMsg] = useState("");
const currentLang = localStorage.getItem("choos__lan") || "1";
const writingMessages = {
  1: {
    required: "Writing savoli majburiy. Iltimos, javob yozing.",
    minWords: "Javob kamida 40 ta so‘zdan iborat bo‘lishi kerak.",
  },
  2: {
    required: "The writing question is required. Please write your answer.",
    minWords: "Your answer must contain at least 40 words.",
  },
  3: {
    required: "Письменный вопрос обязателен. Пожалуйста, напишите ответ.",
    minWords: "Ответ должен содержать не менее 40 слов.",
  },
};
  const navigate = useNavigate();

  const [questions, setQuestions] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [selectedAnswers, setSelectedAnswers] = useState({});
  const [remainingTime, setRemainingTime] = useState(0);
  const [successModal, setSuccessModal] = useState(false);
  const [finishing, setFinishing] = useState(false);

const [writingError, setWritingError] = useState(false);
const [loading, setLoading] = useState(false);
  const intervalRef = useRef(null);

  /* ================== FETCH QUESTIONS + TIME ================== */
  useEffect(() => {
    async function fetchTest() {
      const res = await fetch(
        `https://dev.edu-devosoft.uz/api/test/${localStorage.getItem("choosen_test_id")}`
      );
      const json = await res.json();

      setQuestions(json.questions || []);
      setRemainingTime(json.time * 60);

      localStorage.setItem("start_time", new Date().toISOString());
    }

    fetchTest();
  }, []);

  /* ================== TIMER ================== */
  useEffect(() => {
    if (remainingTime <= 0) return;

    intervalRef.current = setInterval(() => {
      setRemainingTime((prev) => {
        if (prev <= 1) {
          clearInterval(intervalRef.current);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(intervalRef.current);
  }, [remainingTime]);

  const formatTime = (sec) => {
    const m = String(Math.floor(sec / 60)).padStart(2, "0");
    const s = String(sec % 60).padStart(2, "0");
    return `${m}:${s}`;
  };

  /* ================== ANSWER SELECT ================== */
  const selectOption = (questionId, optionId) => {
    setSelectedAnswers((prev) => ({
      ...prev,
      [questionId]: optionId,
    }));
  };

const handleWritingChange = (questionId, text) => {
  setSelectedAnswers((prev) => ({
    ...prev,
    [questionId]: text,
  }));

  if (writingError) {
    setWritingError(false);
    setWritingErrorMsg("");
  }
};


  /* ================== SAVE RESULT ================== */
const finishTest = async () => {
  setWritingError(false);
  setWritingErrorMsg("");

  // 🔍 writing savolni topamiz
  const writingQuestion = questions.find(
    (q) => q.type === "writing"
  );

  if (writingQuestion) {
    const text =
      typeof selectedAnswers[writingQuestion.id] === "string"
        ? selectedAnswers[writingQuestion.id].trim()
        : "";

    const wordCount = text
      ? text.split(/\s+/).filter(Boolean).length
      : 0;

    // ❌ umuman yozilmagan
    if (!text) {
      setWritingError(true);
      setWritingErrorMsg(
        writingMessages[currentLang].required
      );
      alert(writingMessages[currentLang].required);
      return;
    }

    // ❌ 40 ta so‘zdan kam
    if (wordCount < 40) {
      setWritingError(true);
      setWritingErrorMsg(
        writingMessages[currentLang].minWords
      );

          alert(writingMessages[currentLang].minWords);
      return;
    }
  }

  // ================== KEYINGI QISM (ESKI KODING) ==================
  setFinishing(true);
  clearInterval(intervalRef.current);
  setLoading(true);

  const customerTestBody = {
    customer_id: +localStorage.getItem("customerId"),
    test_id: +localStorage.getItem("choosen_test_id"),
    started_at: localStorage.getItem("start_time"),
    finished_at: new Date().toISOString(),
    school_id: 6,
  };

  const res = await fetch(
    "https://dev.edu-devosoft.uz/api/customer-test/",
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(customerTestBody),
    }
  );

  const json = await res.json();
  const customer_test_id = json?.customer_test?.id;

  if (!customer_test_id) {
    setLoading(false);
    alert("Testni yaratishda xatolik");
    return;
  }

  const answersPayload = questions.map((q) => {
    if (q.type === "test") {
      return {
        question_id: q.id,
        option_id: selectedAnswers[q.id],
        customer_test_id,
      };
    }

    if (q.type === "writing") {
      return {
        question_id: q.id,
        writing:
          typeof selectedAnswers[q.id] === "string"
            ? selectedAnswers[q.id].trim()
            : "",
        customer_test_id,
      };
    }

    return null;
  }).filter(Boolean);

  await fetch(
    "https://dev.edu-devosoft.uz/api/customer-answer",
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ list: answersPayload }),
    }
  );

  setLoading(false);
  setSuccessModal(true);
  setFinishing(false);

  setTimeout(() => {
    navigate("/");
  }, 2500);
};


  if (!questions.length)
    return (
      <div className="flex items-center justify-center h-screen">
        <span className="animate-spin w-10 h-10 border-4 border-blue-500 border-t-transparent rounded-full" />
      </div>
    );

  const currentQuestion = questions[currentIndex];
  const progress = ((currentIndex + 1) / questions.length) * 100;

  return (
    <div className="min-h-screen bg-slate-50 flex flex-col">
      {/* ================= HEADER ================= */}
      <div className="sticky top-0 bg-white z-50 border-b px-6 py-4">
        <div className="max-w-5xl mx-auto flex justify-between items-center">
          <div className="font-bold text-[#2D3494]">
            Savol {currentIndex + 1} / {questions.length}
          </div>
          <div className="font-mono text-lg text-red-600">
            {formatTime(remainingTime)}
          </div>
        </div>

        <div className="max-w-5xl mx-auto mt-3 h-2 bg-slate-200 rounded">
          <div
            className="h-full bg-gradient-to-r from-[#2D3494] to-[#4351DB] rounded transition-all"
            style={{ width: `${progress}%` }}
          />
        </div>
      </div>

      {/* ================= QUESTION ================= */}
      <div className="flex-grow flex items-center justify-center px-6">
        <div className="max-w-3xl w-full bg-white rounded-3xl p-8 shadow">
          <h2 id="question" className="text-2xl font-extrabold mb-8  break-words">
            {currentQuestion.question}
          </h2>

          <div className="space-y-4">
            {/* ===== TEST ===== */}
            {currentQuestion.type === "test" &&
              currentQuestion.option.map((opt, i) => (
                <button
                  key={opt.id}
                  onClick={() => selectOption(currentQuestion.id, opt.id)}
                  className={`w-full p-3 rounded-2xl border-2 flex justify-between items-center transition ${
                    selectedAnswers[currentQuestion.id] === opt.id
                      ? "border-[#2D3494] bg-blue-50"
                      : "border-slate-200 hover:bg-slate-50"
                  }`}
                >
                  <span className="font-bold">
                    {String.fromCharCode(65 + i)}. {opt.option}
                  </span>
                  {selectedAnswers[currentQuestion.id] === opt.id && (
                    <span className="w-6 h-6 bg-[#2D3494] rounded-full" />
                  )}
                </button>
              ))}

{currentQuestion.type === "writing" && (
  <>
    <textarea
      value={selectedAnswers[currentQuestion.id] || ""}
      onChange={(e) =>
        handleWritingChange(currentQuestion.id, e.target.value)
      }
      className={`w-full min-h-[160px] p-5 border-2 rounded-2xl
        ${
          // Agar xato bo'lsa qizil
          writingError
            ? "border-red-500 bg-red-50"
            // Agar so'zlar 40 yoki undan ko'p bo'lsa yashil
            : (selectedAnswers[currentQuestion.id]?.trim().split(/\s+/).filter(Boolean).length || 0) >= 40
            ? "border-green-500 bg-green-50"
            // Aks holda default
            : "border-slate-300 focus:border-[#2D3494]"
        }`}
    />

    {writingErrorMsg && (
      <p className="mt-2 text-sm text-red-600 font-medium">
        {writingErrorMsg}
      </p>
    )}
  </>
)}


          </div>
        </div>
      </div>
{successModal && (
  <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
    <div className="bg-white rounded-2xl p-8 w-full max-w-md text-center">
      <h2 className="text-2xl font-bold text-green-600 mb-4">
        Muvaffaqiyatli 🎉
      </h2>

      <p className="text-slate-600 mb-6">
        Test muvaffaqiyatli yakunlandi
      </p>

      <button
        onClick={() => navigate("/")}
        className="px-6 py-3 rounded-xl bg-[#2D3494] text-white font-bold"
      >
        Bosh sahifaga qaytish
      </button>
    </div>
  </div>
)}

      {/* ================= NAV ================= */}
      <div className="flex justify-between px-6 py-6 max-w-5xl mx-auto w-full">
        <button
          disabled={currentIndex === 0}
          onClick={() => setCurrentIndex((p) => p - 1)}
          className="px-8 py-3 rounded-xl bg-white border disabled:opacity-40"
        >
          Oldingi
        </button>

        {currentIndex === questions.length - 1 ? (
         <button
  onClick={finishTest}
  disabled={loading}
  className="px-10 py-3 rounded-xl bg-red-600 text-white font-bold disabled:opacity-60"
>
  {loading ? "Yuklanmoqda..." : "Yakunlash"}
</button>

        ) : (
          <button
            onClick={() => setCurrentIndex((p) => p + 1)}
            className="px-10 py-3 rounded-xl bg-[#2D3494] text-white font-bold"
          >
            Keyingisi
          </button>
        )}
      </div>
      {finishing && (
  <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
    <div className="bg-white rounded-2xl p-8 text-center">
      <div className="w-10 h-10 mx-auto mb-4 border-4 border-[#2D3494] border-t-transparent rounded-full animate-spin"></div>
      <h2 className="text-lg font-bold text-[#2D3494]">
        Yakunlanyapti...
      </h2>
    </div>
  </div>
)}

    </div>
    
  );
}

export default StartTest;
